import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {FilterProductPreview} from "../interface/filter-product-preview";
import {animate, style, transition, trigger} from "@angular/animations";
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {WishlistService} from "../../wishlist/wishlist.service";
import {FilterRelatedProductPreview} from "../interface/filter-related-product-preview";
import {isPlatformBrowser} from "@angular/common";
import {Router} from "@angular/router";
import {ToastMessageService} from "../../services/toast-message.service";

@Component({
	selector: 'fb-filter-product-preview',
	templateUrl: './filter-product-preview.component.html',
	animations: [
		trigger(
			'enterAnimation', [
				transition(':enter', [
					style({transform: 'translateX(0)', opacity: 0}),
					animate('200ms', style({transform: 'translateX(0)', opacity: 1}))
				]),
				transition(':leave', [
					style({transform: 'translateX(0)', opacity: 1}),
					animate('200ms', style({transform: 'translateX(0)', opacity: 0}))
				])
			]
		)
	],
	styleUrls: ['./filter-product-preview.component.scss']
})
export class FilterProductPreviewComponent implements OnInit {

	@Input()
	public index: number = 0;
	@Input()
	public product: FilterProductPreview = {} as FilterProductPreview;

	@Input()
	public relatedProducts: FilterRelatedProductPreview[] = [];

	@Input()
	public productGroup: string = '';

	@Input()
	public selectedCurrency: ApCurrency = ApCurrency.USD;

	@Input()
	public isLoggedIn: boolean = false;

	public isHovered: boolean = false;
	public isBrowser: boolean = false;
	public bulkPrice: number = 0;
	public badge: string = '';


	constructor(
		private _wishlist: WishlistService,
		private _router: Router,
		private _toast: ToastMessageService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	private _getConsumedFabric(): number {
		if(this.product.size_profile_option_list && this.product.size_profile_option_list.length > 0) {
			return this.product.size_profile_option_list[0].size_profile_option_consumed_fabric;
		}
		else if(this.product.made_to_order_profile_consumed_fabric) {
			return this.product.made_to_order_profile_consumed_fabric;
		}

		return 1;
	}

	private _calculateDiscountSlab(consumedFabric: number): number {
		const minOrderQty: number = this.product.minimum_order_quantity? this.product.minimum_order_quantity * consumedFabric: 0;
		let discountSlab: number = 0;
		if(this.product.made_to_order_fabric_discount && this.product.made_to_order_fabric_discount.length > 0) {
			this.product.made_to_order_fabric_discount.sort((a, b) => a.discount - b.discount);
			this.product.made_to_order_fabric_discount.forEach(item => {
				if(item.minimum_order_quantity <= minOrderQty) {
					discountSlab = item.discount;
				}
			})
		}
		return discountSlab;
	}

	private _calculateProductOrderType(): void {
		if(this.product.total_quantity || this.product.made_to_order_fabric_quantity || (this.product.product_size_profile_option_list && this.product.product_size_profile_option_list.length > 0)) {
			if(this.product.total_quantity) {
				if(this.product.product_size_profile_option_list && this.product.product_size_profile_option_list.length > 0)
				{
					if(this.product.product_size_profile_option_list[0].quantity > 0)
						this.badge = 'In Stock';
					else
						this.badge = 'Made to Order';
				}
				else {
					this.badge = 'In Stock';
				}
			}
			else if(this.product.made_to_order_fabric_quantity) {
				if(this.product.product_size_profile_option_list && this.product.product_size_profile_option_list.length > 0)
				{
					if(this.product.product_size_profile_option_list[0].quantity > 0)
						this.badge = 'In Stock';
					else
						this.badge = 'Made to Order';
				}
				else {
					this.badge = 'Made to Order';
				}
			}
			else if(this.product.product_size_profile_option_list && this.product.product_size_profile_option_list[0].quantity > 0)
			{
				this.badge = 'In Stock';
			}
			else {
				this.badge = '';
			}
		}
	}

	ngOnInit() {

		if (this.product.product_group === 'finished') {
			let selectedMadeToOrderFabricPrice: number = this.product.made_to_order_fabric_price ? this.product.made_to_order_fabric_price : this.product.price;
			let consumedFabric: number = this._getConsumedFabric();
			let fabricPrice: number = selectedMadeToOrderFabricPrice * consumedFabric;
			if (this.product.volume_discount) {
				let productVD: number = this.product.price - (this.product.price * (this.product.volume_discount / 100));
				let fabricVD: number = this.product.made_to_order_fabric_discount ? fabricPrice - (fabricPrice * (this._calculateDiscountSlab(consumedFabric) / 100)) : 0;
				this.bulkPrice = productVD + fabricVD;
			} else {
				this.bulkPrice = this.product.calculatedPrice;
			}
		} else {
			if (this.product.volume_discount) {
				this.bulkPrice = this.product.price - (this.product.price * (this.product.volume_discount / 100));
			} else {
				this.bulkPrice = this.product.price;
			}
		}
		this._calculateProductOrderType();
	}

	public toggleWishlist() {
		if(this.isLoggedIn) {
			this._wishlist.toggle(
				this.product.name,
				this.product.sku
			);
		}
		else {
			this.storeUrl();
			this._router.navigate(['/auth']).then(() => {
				this._toast.warning('Please Sign In to add to Wishlist', "Please login into your account to add to the wishlist");
			});
		}
	}

	public storeUrl(): void {
		if (this.isBrowser) {
			localStorage.setItem("storeUrl", window.location.href)
		}
	}
}
